import Button from "../../component/button/Button";
import { seriesListApi } from "../../api/HttpApis";
import { RxImage } from "react-icons/rx";
import { trimStr } from "../../utils/theme/ShortenedText/ShortenedText";
import { useState } from "react";
import { CiImageOn } from "react-icons/ci";

const MediaImage = ({ src, alt }) => {
  const [hasError, setHasError] = useState(false);
  if (hasError || !src) return <CiImageOn size={40} />;
  return (
    <img
      className="imageBox"
      src={src}
      alt={alt || "Media"}
      width={40}
      height={30}
      onError={() => setHasError(true)}
    />
  );
};

export const SeriesData = async (
  selectedDate,
  selectedCreator,
  selectedRating,
  selectedGenre,
  page,
  perpage,
  selectedSeriesFormat,
  qcStatus = ""
) => {
  const response = await seriesListApi(
    {},
    selectedDate,
    selectedCreator,
    selectedRating,
    selectedGenre,
    perpage,
    page,
    "",
    selectedSeriesFormat,
    qcStatus
  );
  const dataArray = Array.isArray(response?.data?.data)
    ? response.data.data
    : [];
  return dataArray.map((item) => ({
    id: item.id,
    name: trimStr(item.name),
    media: item.portrait,
    status: item.status,
    qc_status: item.qc_status,
    rating: item.rating,
    portrait_url: item.portrait,
    landscape_url: item.landscape,
    access: item.access,
    buttonText: "Edit",
    buttonText2: "Remove",
    buttonText3: "Seasons",
    totalCount: response?.data?.total,
  }));
};

export const Columns = (
  navigate,
  handleEdit,
  handleDelete,
  deletingId,
  editingId,
  seasonLoaderId,
  setSeasonLoaderId,
  setSearchQuery
) => {

  const handleSeasonClick = (id) => {
    setSeasonLoaderId(id);
    setSearchQuery(null);
    setTimeout(() => {
      navigate(`/mainlayout/seasons/${id}`);
    }, 300);
  };

  return [
    {
      key: "name",
      label: "Name",
      render: (item) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
            display: "block",
            minWidth: 0,
          }}
        >
          {trimStr(item.name, 15)}
        </div>
      ),
    },
    {
      key: "media",
      label: "Media",
      render: (item) => <MediaImage src={item.media} alt={item.name} />,
    },
    { key: "status", label: "Status" },
    { key: "rating", label: "Rating" },
    { key: "access", label: "Access" },
    {
      key: "buttonText",
      render: (item) => (
        <Button
          onClick={() => handleEdit(item.id)}
          loading={editingId === item.id}
        >
          {item.buttonText}
        </Button>
      ),
    },
    {
      key: "buttonText2",
      render: (item) => (
        <Button
          onClick={() => handleDelete(item.id)}
          loading={deletingId === item.id}
          disabled={deletingId === item.id}
        >
          {deletingId === item.id ? "Deleting..." : item.buttonText2}
        </Button>
      ),
    },
    {
      key: "buttonText3",
      render: (item) => (
        <Button
          onClick={() => handleSeasonClick(item.id)}
          loading={seasonLoaderId === item.id}
        >
          {seasonLoaderId === item.id ? "Loading..." : item.buttonText3}
        </Button>
      ),
    },
  ];
};